module.exports = __webpack_public_path__ + "static/media/new3.428dc3ad.jpg";